// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ia-0";
export var leftAlign = "_ia-4";
export var listItem = "_ia-2";
export var listItemWrapper = "_ia-1";
export var operationText = "_ia-3";